import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from '@mui/material';

export const ConfirmModal = ({ open, title, message, cancelText = 'Cancel', confirmText = 'Confirm', loading, onCancel, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700, pb: 1.5 }}>{title}</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <DialogContentText sx={{ color: 'text.secondary' }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 1, p: 2, pt: 0 }}>
        <Button onClick={onCancel} disabled={loading} size="small">
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained" 
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : undefined}
          size="small"
        >
          {loading ? 'Processing' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
